import { useEffect } from "react";
import DepartmentResources from "./components/departmentResources";
import PowerBiResult from "./components/powerBiResult";
import { IStaffDashboard } from "../../../models/dashboard/staffDashboard";
import { useDispatch } from "react-redux";
import { connect } from "react-redux";
import CampusSafety from "./components/campusSafety";
import PopularTraining from "./components/popularTraining";
import HrAndBenifit from "./components/HrAndBenifits";
import CampusEvents from "./components/campusEvents";
import TechnoloryResourses from "./components/technoloryResourses";
import FinanceResources from "./components/financeResources";
import { getCurrentUserData } from "../../../action/user/userProfileActionCreator";
import { getSnapShots } from "../../../action/masters/snapShotActionCreator";
import { pageBlockId } from "../../../constants/pageBlocks";
import { getPageBlockData, greetings } from "../../../common-functions/commonFunctions";
import PrimeCalendar from "../../../common-components/calendar/monthCalendar";
import { setSnapShots } from "../../../store/slices/master/snapShotSlice";

const StaffDashboard = (props: IStaffDashboard) => {
  const { userInfo, getSnapShots } = props;

  const dispatch = useDispatch();

  useEffect(() => {
    getSnapShots();
  }, []);

  useEffect(() => {
    return () => {
      dispatch(setSnapShots([]));
    }
  }, []);

  return (
    <>
      <div className="row mb-3 stafdash-mobile">
        <div className="dash-title col-lg-6">
          <h2 className="mb-2">{greetings()}, {userInfo?.displayName}</h2>
          <p>Welcome! Access your workspace to review operational Widgets and Apps.  Access the sidebar menu to view all your departmental and campus resources.</p>
        </div>
      </div>
      <div className="row mb-s3">
        <div className="col-lg-8 mb-3">
          <div className="row h-100">
            <div className="col-lg-12 mb-3">
              <DepartmentResources />
            </div>
            <div className="col-lg-12">
              <PowerBiResult />
            </div>
          </div>
        </div>
        <div className="col-lg-4 mb-3">
          <PrimeCalendar />
        </div>
        <div className="col-lg-4  mb-3">
          <HrAndBenifit />
        </div>
        <div className="col-lg-4 mb-3">
          <FinanceResources />
        </div>
        <div className="col-lg-4 mb-3">
          <PopularTraining />
        </div>
        <div className="col-lg-4 mb-3">
          <TechnoloryResourses />
        </div>
        <div className="col-lg-4 mb-3">
          <CampusEvents />
        </div>
        <div className="col-lg-4 mb-3">
          <CampusSafety />
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getSnapShots: () => getSnapShots(),
};

function mapStateToProps(state: any) {
  return {
    userInfo: state.userDetails.userProfileData,
    snapShots: state.snapShot.snapShots,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(StaffDashboard);
